export const state = {
  KEY: localStorage.getItem('hs_key') || '',
  img64: null,
  imgThumb: null,
  fakeImg64: null,
  lastResult: null,
  collection: JSON.parse(localStorage.getItem('hs_col') || '[]'),
  scanHistory: JSON.parse(localStorage.getItem('hs_hist') || '[]'),
  alerts: JSON.parse(localStorage.getItem('hs_alerts') || '[]'),
  achievements: JSON.parse(localStorage.getItem('hs_ach') || '[]'),
  sortBy: 'date',
  filterBy: 'all',
  colView: localStorage.getItem('hs_col_view') === 'grid' ? 'grid' : 'list',
  searchQuery: '',
  currentMode: 'photo',
  currentSeries: 'mainline',
  timerInt: null,
  timerSec: 0,
  _sb: null,
  currentUser: null,
  userProfile: null,
  multiImages: [],
}
